import { Component, Vue } from 'vue-property-decorator';
import WithRender from './App.html';
// Components
import BreadCrumb from '@/components/Breadcrumb/Breadcrumb';

@WithRender
@Component({
  components: {
    BreadCrumb,
  },
})
export default class App extends Vue {}
